import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable } from 'rxjs';

export const msalInterceptor: HttpInterceptorFn = (req, next) => {
    const msalService = inject(MsalService);
    const account = msalService.instance.getAllAccounts()[0];

    // Add your API URL pattern
    const requiresAuth =
        req.url.indexOf('/graphql') > -1;  // Adjust this pattern to match your API URLs

    if (!requiresAuth) {
        return next(req);
    }

    return new Observable(observer => {
        msalService.acquireTokenSilent({
            account: account,
            scopes: []
        }).subscribe({
            next: (tokenResponse) => {
                const authReq = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${tokenResponse.accessToken}`
                    }
                });
                next(authReq).subscribe(observer);
            },
            error: (error) => {
                observer.error(error);
            }
        });
    });
};
